import { Component, OnInit, EventEmitter, Input, ViewChildren, Output, Renderer2 } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { LayoutService } from '../../services/layout.service';
import { TranslateService } from '@ngx-translate/core';
import { JwtAuthService } from 'app/auth/services/jwt-auth.service';
import { LocalStoreService } from 'app/shared/services/local-store.service';
import { IdentityAuthService } from 'app/auth/services/identity-auth.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { LanguageService } from 'app/shared/services/language.service';

@Component({
  selector: 'app-header-side',
  templateUrl: './header-side.template.html'
})
export class HeaderSideComponent implements OnInit {
  @Input() notificPanel;
  APP_USER = "EGRET_USER";

  public availableLangs = [{
    name: 'Ћирилица',
    code: 'sr-Cyrl-RS',
    flag: 'flag-icon-rs'
  }/*,
  {
    name: 'Latinica',
    code: 'sr-Latin-RS',
    flag: 'flag-icon-rs'
  }*/];

  currentLang = this.availableLangs[0];

  public egretThemes;
  public layoutConf: any;
  public imeKorisnika;
  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    public jwtAuth: JwtAuthService,
    public translate: TranslateService,
    private renderer: Renderer2,
    private router: Router,
    private identityAuthService: IdentityAuthService
  ) { }
  ngOnInit() {
    this.egretThemes = this.themeService.egretThemes;
    this.layoutConf = this.layout.layoutConf;
    let lngCode = localStorage.getItem(LanguageService.LANG_CACHE_KEY);
    if (lngCode) {
      let lng = this.availableLangs.find(l => l.code == lngCode);
      if (lng) {
        this.currentLang = lng;
      }
    }
    this.translate.use(this.currentLang.code);
    this.imeKorisnika = this.jwtAuth.getUser()?.displayName;
  }

  setLang(lng) {
    this.currentLang = lng;
    this.translate.use(lng.code);
    localStorage.setItem(LanguageService.LANG_CACHE_KEY, lng.code);
  }

  changeTheme(theme) {
    // this.themeService.changeTheme(theme);
  }

  toggleNotific() {
    this.notificPanel.toggle();
  }

  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full'
      })
    }
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed'
    })
  }

  toggleCollapse() {
    // compact --> full
    if (this.layoutConf.sidebarStyle === 'compact') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full',
        sidebarCompactToggle: false
      }, { transitionClass: true })
    }

    // * --> compact
    this.layout.publishLayoutChange({
      sidebarStyle: 'compact',
      sidebarCompactToggle: true
    }, { transitionClass: true })

  }

  onSearch(e) { }

  logout() { }

  signout() {
    if (!!!environment.enableSSO) {
      this.jwtAuth.signout()
    } else {
      this.identityAuthService.logOut();
    }
  }
}